export type NavLink = {
    id: string
    label: string
}

export const navLinks: Array<NavLink> = [
    { id: 'realms', label: 'Realms' },
    { id: 'adoptions', label: 'Adoptions' },
    { id: 'breeding', label: 'Breeding' },
    { id: 'quests', label: 'Quests' },
    { id: 'forums', label: 'Forums' },
    { id: 'contact', label: 'Contact' },
]

